import { useFeature, WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledLetsGoTokyoLogo,
    StyledListenButton,
    StyledTheWestLiveLogo,
    StyledThor,
    StyledTokyoContainer,
    StyledTokyoFooter,
    StyledTokyoFooterText,
    StyledTokyoSectionHeader,
} from '../../compositions/Thor/Thor.styled'
import { ThemeOverrider } from '../../themes/ThemeOverrider/ThemeOverrider'
import { ContainerWidth, ThemeMargins } from '../../__styling/settings/metrics'
import { ThemeOverrideTypes } from '../../__styling/themes'

export interface ThorProps {
    mainContent: React.ReactElement<any>
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
    themeOverride?: ThemeOverrideTypes
    usePodcastToggleValue?: boolean
}

export const Thor: React.FC<ThorProps> = ({
    mainContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    containerWidth,
    themeOverride,
    usePodcastToggleValue,
}) => {
    const showTokyoPodcast = useFeature('the-west-tokyo-podcast')
    const useStylingForHiddenPodcast = usePodcastToggleValue
        ? !showTokyoPodcast
        : false

    const styledThor = (
        <StyledThor
            hasBackgroundFill={hasBackgroundFill}
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            containerWidth={containerWidth || 1020}
            useStylingForHiddenPodcast={useStylingForHiddenPodcast}
        >
            {mainContent}
        </StyledThor>
    )

    if (themeOverride === 'tokyo') {
        return (
            <ThemeOverrider override={themeOverride}>
                <StyledTokyoContainer>
                    <WebLink to="/sport/olympics">
                        <StyledLetsGoTokyoLogo className="medalTally__letsGoLogo" />
                    </WebLink>

                    <StyledTokyoSectionHeader
                        heading="Full Coverage"
                        headingUrl="/sport/olympics"
                        showChevron
                    />
                </StyledTokyoContainer>
                {styledThor}
                {showTokyoPodcast ? <TokyoFooter /> : null}
            </ThemeOverrider>
        )
    }

    return (
        <ThemeOverrider override={themeOverride}>{styledThor}</ThemeOverrider>
    )
}

export const TokyoFooter = () => {
    return (
        <StyledTokyoFooter>
            <StyledTheWestLiveLogo />

            <StyledTokyoFooterText>
                Your daily talk show with Olympics coverage
            </StyledTokyoFooterText>

            <StyledListenButton to="/sport/olympics/podcast">
                Listen Now
            </StyledListenButton>
        </StyledTokyoFooter>
    )
}

Thor.displayName = 'ThorComposition'
